/** Placeholder until invite templates are loaded from EZ Manage configurations. */
export interface InviteEmailTemplateOption {
    id: string
    label: string
}

export const INVITE_EMAIL_TEMPLATE_OPTIONS: InviteEmailTemplateOption[] = [
    { id: 'default', label: 'Default account invite' },
]

export function labelForInviteTemplate(templateId: string | undefined): string {
    if (!templateId) {
        return (
            INVITE_EMAIL_TEMPLATE_OPTIONS[0]?.label ?? 'Default account invite'
        )
    }
    return (
        INVITE_EMAIL_TEMPLATE_OPTIONS.find((option) => option.id === templateId)
            ?.label ?? templateId
    )
}
